import { CookieKeys } from '../../../../../enums/cookieKeys'
import { useOrganizationViewUrl } from '../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../utils/routing/reactRoute'
import { buildEditorBackButtonUrl } from '../../../utils/buildEditorBackButtonUrl'
import { quoteEditorVariants } from '../constants/variants/quoteEditorVariants'
import { recurringInvoiceEditorVariants } from '../constants/variants/recurringInvoiceEditorVariants'
import { useInvoiceEditorVariant } from './useInvoiceEditorVariant'

export const useInvoiceEditorBackButtonUrl = () => {
  const { invoiceEditorVariant } = useInvoiceEditorVariant()
  const { url: invoicesUrl } = useOrganizationViewUrl(reactRoute.organization.invoices.getMainRoute())
  const { url: quotesUrl } = useOrganizationViewUrl(reactRoute.organization.quotes.getMainRoute())
  const { url: recurringInvoicesUrl } = useOrganizationViewUrl(reactRoute.organization.recurringInvoices.getMainRoute())

  const backToInvoicesUrl = buildEditorBackButtonUrl(invoicesUrl, CookieKeys.InvoicingInvoicesListQuery)
  const backToQuotesUrl = buildEditorBackButtonUrl(quotesUrl, CookieKeys.QuotesListQuery)
  const backToRecurringInvoicesUrl = buildEditorBackButtonUrl(
    recurringInvoicesUrl,
    CookieKeys.RecurringInvoicesListQuery,
  )

  let backButtonUrl: string | undefined

  if (quoteEditorVariants.includes(invoiceEditorVariant)) {
    backButtonUrl = backToQuotesUrl
  } else if (recurringInvoiceEditorVariants.includes(invoiceEditorVariant)) {
    backButtonUrl = backToRecurringInvoicesUrl
  } else {
    backButtonUrl = backToInvoicesUrl
  }

  return { backButtonUrl }
}
